import UIManager from "../../Shared/UIManager";
import { Global } from "../../Shared/Global";
const i18n = require('LanguageData');
const { ccclass, property } = cc._decorator;

@ccclass
export default class IRechargeLayer extends cc.Component {
    @property({ type: Object, visible: false })
    parentConfig: Object = null

    @property(Array)
    private _configs: Array<any> = []

    @property({ type: Array, visible: false })
    set configs(value) {
        this._configs = value
        this.refreshData()
    }

    get configs() {
        return this._configs
    }

    protected refreshData() {

    }

    checkMoney(money) {
        if (/^[0-9]+.?[0-9]*$/.test(money)) {
            return true
        } else if (!money) {
            UIManager.showToastUI(i18n.t('BasicsJS.inp_amount'), Global.ToastType.Warnning)
        } else {
            UIManager.showToastUI(i18n.t('BasicsJS.inp_correct_amount'), Global.ToastType.Warnning)
        }

        return false
    }

    onEditMoneyEnded(editBox: cc.EditBox) {
        let money = parseFloat(editBox.string) || 0
        let nums = money.toString().split(".")
        if (nums[1] && nums[1].length > 2) {
            editBox.string = money.toFixed(2)
            editBox.string === "0.00" && (editBox.string = "")
        } else {
            editBox.string = money > 0 ? money.toString() : ""
        }
    }
}
